import styled from 'styled-components';

export const Title = styled.h2`
  color: ${({ theme }) => theme.colors.dark.hex()};
  font-size: ${({ theme }) => theme.sizes.h2};
  font-weight: ${({ theme }) => theme.weights.strong};
  line-height: ${({ theme }) => theme.lineHeights.title};
  margin: 0 0 2.4rem 0;
`;
